import strings from '../strings';
import * as no from '../assets/testAnswers/no';
import * as nn from '../assets/testAnswers/nn';
import * as de from '../assets/testAnswers/de';
import * as se from '../assets/testAnswers/se';

export const getTestLanguage = () => {
	switch (strings.getLanguage()) {
		case 'no':
			return no;
		case 'nn':
			return nn;
		case 'de':
			return de;
		case 'se':
			return se;
		default:
			return no;
	}
};

export const getWorkingMemory = () => ({
	stages: [
		'Intro',
		'Trial',
		'Pause',
		'numbers',
		'Pause',
		'Intro',
		'Trial',
		'Pause',
		'words',
		'Pause',
	],
	getNumberSteps: () => {
		return getTestLanguage().WMNAnswers;
	},
	getWordSteps: () => {
		return getTestLanguage().WMWAnswers;
	},
	getIntroSteps: () => {
		return [];
	},
	getNumberTrialSteps: () => {
		return getTestLanguage().WMNTrialAnswers;
	},
	getWordTrialSteps: () => {
		return getTestLanguage().WMWTrialAnswers;
	},
});

export const getSpoonerism = () => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().SpoonerismAnswers;
	},
	getIntroSteps: () => {
		return ['intro', ...getTestLanguage().SpoonerismIntroTasks, 'summary'];
	},
});

export const getRapidNaming = (ageGroup) => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		if (ageGroup === 0 || ageGroup === 1)
			//Flattens 2D array to 1D by merging
			return [].concat(...getTestLanguage().kdrnAnswers);
		else return [].concat(...getTestLanguage().rnAnswers);
	},
	getAnswers: () => {
		let testItems = [];
		if (ageGroup === 0 || ageGroup === 1)
			testItems = JSON.parse(
				JSON.stringify(getTestLanguage().kdrnAnswers)
			);
		else
			testItems = JSON.parse(JSON.stringify(getTestLanguage().rnAnswers));

		return testItems;
	},
	getIntroSteps: () => {
		return getTestLanguage().rnIntroSteps;
	},
});

export const getPhonemeIsolation = (testKeyType, ageGroup) => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().phonemeIsolationNormingTasks;
	},
	getIntroSteps: () => {
		return getTestLanguage().phonemeIsolationIntro;
	},
});

export const getOneMinute = () => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().oneMinuteTasks;
	},
	getIntroSteps: () => {
		return [];
	},
});

export const getLetterKnowledge = (testKeyType, ageGroup) => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return testKeyType === 'youth-followup' ||
			testKeyType === 'adult-followup'
			? getTestLanguage().lkAnswersNorming
			: ageGroup === 0 || ageGroup === 1
			? getTestLanguage().kdlkAnswers
			: getTestLanguage().lkAnswers;
	},
	getIntroSteps: () => {
		return [];
	},
});

export const getPhonemeDeletion = () => ({
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return getTestLanguage().pdSteps.slice();
	},
	getAnswers: () => {
		return getTestLanguage().pdAnswers;
	},
	getIntroSteps: () => {
		return ['intro', ...getTestLanguage().pdIntroSteps, 'outro'];
	},
});

export const getWordDictation = (testKeyType) => ({
	//Word Dictation
	stages: ['Intro', 'Test', 'Pause'],
	getSteps: () => {
		return testKeyType === 'youth-followup' ||
			testKeyType === 'adult-followup'
			? getTestLanguage().wdAnswersNorming.slice()
			: getTestLanguage().wdAnswers.slice();
	},
	getIntroSteps: () => {
		return [];
	},
});

export const tests = {
	LetterKnowledge: getLetterKnowledge,
	WorkingMemory: getWorkingMemory,
	RapidNaming: getRapidNaming,
	PhonemeIsolation: getPhonemeIsolation,
	PhonemeDeletion: getPhonemeDeletion,
	OneMinute: getOneMinute,
	WordDictation: getWordDictation,
	Spoonerism: getSpoonerism,
};
export default tests;
